import { render, staticRenderFns } from "./MisCompras.vue?vue&type=template&id=4e2c4782&scoped=true"
import script from "./MisCompras.vue?vue&type=script&lang=js"
export * from "./MisCompras.vue?vue&type=script&lang=js"
import style0 from "./MisCompras.vue?vue&type=style&index=0&id=4e2c4782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2c4782",
  null
  
)

export default component.exports